import axios from "axios";
import { plainToClass } from "class-transformer";
import { validate } from "class-validator";
import { CreateCategoryDTO } from "../../dto";

type CreateCategoryProps = {
  title: string;
};

let body: CreateCategoryDTO;

export async function createCategoryAction(props: CreateCategoryProps) {
  const token = localStorage.getItem("token");

  const params = {
    title: props.title,
  };

  return await axios
    .post(
      `${process.env.REACT_APP_API_ORIGIN}/1.0.0/cms/categories/create`,
      params,
      {
        headers: {
          "Content-Type": "application/json",
          "app-platform": "cms",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then(async (res) => {
      body = plainToClass(CreateCategoryDTO, res.data);
      await validate(body);
      const errors = await validate(body);
      if (errors.length > 0) {
        throw errors;
      }

      return res.data;
    });
}
